import script from "./Home.vue?vue&type=script&setup=true&lang=ts"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=3b5b0755&scoped=true&lang=stylus"
script.__scopeId = "data-v-3b5b0755"

export default script